import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Layout from '../layout';

function Public({ component: Component, auth, ...rest }: any) {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const acceptedTerms = useSelector(
    (state: ApplicationState) => state.auth.user?.acceptedTerms
  );
  const terms = useSelector(
    (state: ApplicationState) => state.config.termosUso
  );
  return (
    <Route
      {...rest}
      render={(props) => {
        let toRender;

        if (token && rest.path !== '/faq') {
          if (acceptedTerms) {
            toRender = <Redirect to='/acordos-debitos' />;
          } else if (terms) {
            toRender = <Redirect to='/termos' />;
          } else {
            toRender = <Redirect to='/acordos-debitos' />;
          }
        } else {
          toRender =
            rest.path === '/' ? (
              <Component {...props} />
            ) : (
              <Layout>
                <Component {...props} />
              </Layout>
            );
        }

        return toRender;
      }}
    />
  );
}

export default Public;
